import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

// import LoginAuditsGridlayout from './containers/Grid';

export default function LoginAuditLayout() {
  return <Router>
    {/* <PrivateRoute exact path="/admin/loginAudit" component={LoginAuditsGridlayout} /> */}
  </Router>
}
